import FlotaSection from './FlotaSection';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchCategories } from 'actions';

const mapStateToProps = ({ global, siteConfiguration, bookings }) => ({
  listCategories: global.listCategories,
  settings: siteConfiguration.settings,
  bookingsConfiguration: bookings.configuration,
});

export default connect(mapStateToProps, { fetchCategories })(withTranslation()(FlotaSection));
